export const FIELD_LABELS = {
    images: 'Fotos',
    name: 'Título',
    description: 'Descrição',
    tech_description: 'Descrição técnica',
    categories: 'Categorias',
    seo: 'SEO',
    min_quantity: 'Quantidade mínima',
    customizations: 'Gravações'
};

export const UNAVAILABLE_REASONS = {
    source_deleted: 'O produto original saiu de linha ou foi excluído. Fora do site até trocar o vínculo.',
    no_price: 'O produto original ainda não tem preço do fornecedor. Fora do site até o preço chegar.'
};

export const describeCustomizedFields = fields => {
    if (!fields || fields.length === 0) return 'Igual ao original';

    const labels = fields.map(field => FIELD_LABELS[field]?.toLowerCase()).filter(Boolean);
    const last = labels.pop();

    return `Personalizado: ${labels.length ? `${labels.join(', ')} e ${last}` : last}`;
};
